import type { Order } from "../Order.js";
import { getAppliedVoucherValue } from "./getAppliedVoucherValue.js";

export function getPriceOfOrderToPay({ price, appliedVoucher }: Pick<Order, "price" | "appliedVoucher">): {
	voucherValue: number | undefined;
	priceOfOrderToPay: number;
} {
	const voucherValue = appliedVoucher ? getAppliedVoucherValue(appliedVoucher, price) : undefined;
	const priceOfOrderToPay =
		voucherValue !== undefined ? Math.max(price.totalPrice.withTax - voucherValue, 0) : price.totalPrice.withTax;

	return { voucherValue, priceOfOrderToPay };
}
